module.exports = __webpack_public_path__ + "img/cure-1.49e6fb42.png";